import React from 'react'

const OpsGenieIcon = React.memo(() => (
    <svg viewBox="0 0 1024 1024" data-icon="opsgenie" height="1em" width="1em" fill="currentColor" aria-hidden="true">
        <circle cx="512.552" cy="261.085" r="251.085" />
        <path
            d="M920.726,556.195c-0.424-0.236-0.851-0.461-1.285-0.674l-190.284-93.314c-13.301-6.486-29.353-1.566-36.734,11.259
		c-48.855,81.909-109.613,155.421-179.856,218.377c-70.248-62.958-131.015-136.471-179.883-218.377
		c-7.381-12.825-23.433-17.746-36.734-11.259l-190.145,93.314c-0.453,0.221-0.901,0.453-1.341,0.698
		c-13.583,7.562-18.465,24.702-10.903,38.287c97.24,168.451,233.619,311.009,397.6,415.614c13.089,8.174,29.694,8.174,42.786,0
		c164.002-104.578,300.385-247.142,397.6-415.614C939.136,580.939,934.291,563.789,920.726,556.195z"
        />
    </svg>
))

export default OpsGenieIcon
